<template>
  <div
    :class="{
      'data-cell-control': true,
    }"
    @click.stop
  >
    <component
      :is="componentConstructor"
      v-if="hasContent"
      v-bind="componentProps"
      v-on="componentEvents"
      >{{ componentContent }}
    </component>
    <template v-else>-</template>
  </div>
</template>

<script setup lang="ts">
import type { Renderable } from "@/components/controls/grid/BmGridData";
import { computed } from "vue";

interface DataCellControlProps {
  // If the context is appropriate the row item data this renderer is rendering a cell for.
  item?: unknown;
  context?: Renderable;
}

const props = defineProps<DataCellControlProps>();

const componentConstructor = computed(() => {
  return props.context!.rendererMetadata.control.component;
});
const componentProps = computed(() => {
  return (
    props.context!.rendererMetadata.control.propBinder &&
    props.context!.rendererMetadata.control.propBinder(props.item)
  );
});
const componentEvents = computed(() => {
  return (
    props.context!.rendererMetadata.control.eventBinder &&
    props.context!.rendererMetadata.control.eventBinder(props.item)
  );
});
const componentContent = computed(() => {
  return (
    props.context!.rendererMetadata.control.contentBinder &&
    props.context!.rendererMetadata.control.contentBinder(props.item)
  );
});
const hasContent = computed(() => {
  return (
    componentProps.value || componentContent.value || componentEvents.value
  );
});
</script>

<style lang="sass" scoped>
:deep(button)
  padding: 0

// Style embedded controls to hide elements that make the control too tall for the grid row.
.data-cell-control :deep(.bm-text)
  padding: 0

.data-cell-control :deep(button)
  margin-top: 5px

.data-cell-control :deep(.v-text-field__details), .data-cell-control :deep(.bm-label)
  display: none

// Make inline block so we don't block row clicks by taking full space (we use @click.stop above)
.data-cell-control
  display: inline-block
</style>
